import { Box, Button, Container, Grid, Link, Typography } from "@mui/material";
import React from "react";
import tamperproof_blue from "../../assets/logo-blue.png";

const Footer = () => {
	const email = "support@policecerts.com";
	const termsOfServiceUrl = "https://www.policecerts.com/terms-of-service";
	return (
		<Box sx={{ backgroundColor: "#f5f7fb", padding: 2 }}>
			<Container maxWidth="xl" padding={2}>
				<Grid container>
					<Grid item xs={12} md={6} textAlign="center" display="flex" alignItems="center" justifyContent="center" gap={1}>
						<img src={tamperproof_blue} height="60px" alt="policecerts logo" />
						<Typography variant="h6" fontWeight="bold" color="primary">
							Police Certs
						</Typography>
					</Grid>
					<Grid item xs={12} md={6} textAlign="center">
						<Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" gap={2}>
							<Link href={termsOfServiceUrl} style={{ textDecoration: "underline", color: "inherit", fontSize: "12px" }} target="_blank">
								TERMS OF SERVICE / PRIVACY & DATA PROTECTION
							</Link>
							<Button variant="contained" color="primary" onClick={() => window.open(`mailto:${email}`, "_blank")}>
								Contact Support
							</Button>
						</Box>
					</Grid>
				</Grid>
				<Box>
					<Typography variant="body2" textAlign="center">
						© {new Date().getFullYear()} Police Certs. All rights reserved.
					</Typography>
				</Box>
			</Container>
		</Box>
	);
};

export default Footer;
